import { isUnassignedZoneKey, UNASSIGNED_ZONE_LABEL } from '@/utils/unassignedReservationZone';

export function venueRoomLabel(room) {
	if (!room) return '—';
	return room.effectiveDisplayName ?? room.displayName ?? room.name ?? '—';
}

export function roomLabelForSystemName(tables, systemRoom) {
	if (isUnassignedZoneKey(systemRoom)) return UNASSIGNED_ZONE_LABEL;
	if (!systemRoom || !Array.isArray(tables)) return systemRoom ?? '—';
	const table = tables.find((t) => t.room === systemRoom);
	return table?.roomLabel ?? systemRoom;
}
